export default __webpack_public_path__ + "static/media/no-result-transparent.90d506bb.png";